module.exports = "https://cdn-challenge.mathletics.com/app/111/assets/images/dffaa07cfcf9a1d5344dc45dfd431325.svg";